module.exports = __webpack_public_path__ + "img/banner.c6d4dd3c.svg";